import React, { useState } from 'react'
import { Breadcrumb, Row, Col, InputGroup, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { InboxOutlined } from '@ant-design/icons'
import { faGlobe, faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { blogAlert, blogId, blogItem, blogList, blogRefresh, blogResponse, createBlogID, createBlogModal, gallery } from '../../../states/blogs';
import { BlogCard } from './BlogCard';
import AlertToast from '../../../components/AlertToast';
import BlogModal from './Modal';
import { useLocation, useParams } from 'react-router-dom';
import { Form, Input, Modal, Pagination, Upload, Button as AntButton, Card, } from 'antd';
import { dummyRequest } from '../../../services/utilities';
import { createImgGal } from '../../../services/apiCalls';
import Text from 'antd/lib/typography/Text';
import Meta from 'antd/lib/card/Meta';

const Blogs = () => {
  // const blog = useRecoilValueLoadable(blogList)
  const params = useParams()
  const [blogid, setBlogId] = useRecoilState(blogId)
  setBlogId(params.id)
  const blog = useRecoilValue(blogItem)
  const galla = useRecoilValue(gallery)
  const [response, setResponse] = useRecoilState(blogResponse)
  const setRefresh = useSetRecoilState(blogRefresh)
  const setShowModal = useSetRecoilState(createBlogModal)
  const [showAlert, setShowAlert] = useRecoilState(blogAlert)
  const location = useLocation()
  const {state} = location
  const { title, description} = state  
  
  const [viewModal, setViewModal] = useState(false)
  const [imageModal, setImageModal] = useState(false)
  const [form] = Form.useForm();
  const [file, setFile] = useState("")
  const [loading, setLoading] = useState(false)

  const data = blog?.data && blog?.data
  console.log(galla)
  // const blogs = blog.state === "hasValue" && blog.contents.productCategories ? blog.contents.productCategories : []
  // const meta = data.state === "hasValue" && data.contents.meta ? data.contents.meta : {}
  // const { data } = blogs

  const handleCreate = () => {
    setResponse({})
    setShowModal(true)
  }
  const openImage = () => {
    setImageModal(true)
  } 
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };

  const handleSubmit = async (val) => {
    const date = new Date()
    setLoading(true)
    if (file !== "") {
      const fd = new FormData();
      fd.append('title', val.title)
      fd.append('parent_id', val.parent_id)
      fd.append('short_content', val.short_content)
      fd.append('file', file);
      const res = await createImgGal(fd)
      if (res.status) {
        setResponse({ message: res.message, title: "success" })
        setShowAlert(true)
        setRefresh(date.toTimeString())
        setImageModal(false)
        setFile("")
        form.resetFields()
      } else {
        setResponse({ message: res.message || res, title: "failed" })
        setShowAlert(true)
      }
    }
    setLoading(false)
  }
  // pagination
  const pagesize = 20
  const [from, setFrom] = useState(0)
  const blogData = [...data]
  const handlePagination = (value)=>{
      setFrom(pagesize*(value-1))
  }
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Blog" />
      <BlogModal parentId={params.id} />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>Blogs</Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Manage Posts: {title}</h4>
          <p>{description}</p>
        </div>
      </div>
      <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col xs={6} md={6} lg={3} xl={4}>
            
            <Button onClick={() => setViewModal(true)} className="me-2 mb-2" variant="secondary" size="sm">
              View Image Gallery<FontAwesomeIcon icon={faEye} />
            </Button>
          </Col>
          <Col xs={6} md={6} xl={6} className="ps-md-0 text-end">
            <Button variant="secondary" className="text-dark me-3" onClick={handleCreate}>
              Create Blog Post <FontAwesomeIcon icon={faGlobe} className="d-none d-sm-inline ms-1" />
            </Button>
            <Button variant="secondary" className="text-dark me-3" onClick={openImage}>
              Add Image to Gallery<FontAwesomeIcon icon={faGlobe} className="d-none d-sm-inline ms-1" />
            </Button>
          </Col>
        </Row>
      </div>
      {/* <Row>
        {data && data &&
        data.map((b, index) => (
          <Col key={index} xs={12} xl={4} lg={4} md={6}>
            <BlogCard data={b} />
          </Col>))}
      </Row> */}
      <Row>
        {blogData && blogData &&
        // blogData.map((b, index) => (
        blogData?.splice(from, pagesize).map((b, index) => (
          <Col key={index} xs={12} xl={4} lg={4} md={6}>
            <BlogCard data={b} />
          </Col>))}
      </Row>
      <div aria-label="Page  navigation example">
        <ul className="justify-content-center pagination">
          <Pagination 
            onChange={handlePagination} 
            defaultCurrent={1} 
            total={data?.length} 
            pageSize={pagesize}
          />
        </ul>
      </div>        
      
      <Modal
        title="Add Image to Gallery"
        centered
        visible={imageModal}
        footer={null}
        onCancel={() => setImageModal(false)}
      >
        <div className="card">
          <div className="card-body">
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Form.Item label="Image Title" name="title" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              {/* <Form.Item >
                <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                  <Button icon={<InboxOutlined />}>Upload Blog Image</Button>
                </Upload>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Create
                </Button>
              </Form.Item> */}
              <Form.Item >
                <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                  <AntButton icon={<InboxOutlined />}>Upload Blog Image</AntButton>
                </Upload>
              </Form.Item>
              <Form.Item>
                <AntButton type="primary" htmlType="submit" loading={loading}>
                  Submit
                </AntButton>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>

      
      <Modal
        title="Images Grid"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
        width={1000}
      >
        <Row>
              {galla?.map((b, i)=>(
            <Col xs={12} xl={4} lg={4} md={6}>
                <Card
                  hoverable
                  style={{
                    width: 240,
                  }}
                  cover={<img alt="example" src={b.imageurl} />}
                >
                  <Meta title={b.title} />
                  <Text copyable={{icon:<AntButton type='primary' style={{border:'0 none'}}>Copy</AntButton>}}>{b.imageurl}</Text>
                </Card>
            </Col>
              ))}
        </Row>
      </Modal>
    </div>
  )
}

export default Blogs
